import React from 'react'

import useInterval from './useInterval'

const lerp = (a: number, b: number, t: number) => a + t * (b - a)

const useLinearImpulse = (
  from: number,
  to: number,
  duration: number = 1000,
  refreshRate: number = 50,
) => {
  const [elapsedTime, setElapsedTime] = React.useState(0)
  const [start, setStart] = React.useState(Date.now())

  useInterval(() => {
    const now = Date.now()
    setElapsedTime(elapsedTime + (now - start))
    setStart(now)
  }, refreshRate)

  return lerp(from, to, Math.min(1, Math.max(0, elapsedTime / duration)))
}

export default useLinearImpulse
